/* @sravni/react-design-system version 0.2.71 */
var css = "._rnyb3 {\n  width: 100%;\n}\n";
var modules_8f2c8bee = {"container":"_rnyb3"};
import "../../../assets/components/MaskInput/src/MaskInput-f7a5cb68.css";

export default modules_8f2c8bee;
export { css };
